export const toasterNotificationConfig = {
	displayLimit: 9,
	displayTimeInSeconds: 5,
}